/* eslint-disable jsx-a11y/label-has-for */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import subscriberApi from '../../../../js/utils/subscriberApi';
import './styles.scss';

const {
  i18n: {
    __,
  },
} = wp;

/**
 * Newsletter widget component.
 */
export default class NewsletterWidget extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    newsletterId: PropTypes.string,
    footerSignup: PropTypes.bool,
    privacyLink: PropTypes.string,
    newsletterLink: PropTypes.string,
    nonce: PropTypes.string.isRequired,
    showTermsBox: PropTypes.bool,
    useNewsletterIds: PropTypes.bool,
    newsletterIds: PropTypes.bool,
  };

  static defaultProps = {
    title: '',
    description: '',
    newsletterId: '',
    newsletterIds: [],
    footerSignup: false,
    privacyLink: '',
    newsletterLink: '',
    showTermsBox: false,
    useNewsletterIds: false,
  };

  state = {
    email: '',
    newsletterIds: [],
    isLoading: false,
    isSuccess: false,
    termsChecked: false,
    invalidEmail: false,
    invalidTerms: false,
    invalidNewsletterSelection: false,
    invalidNewletterIds: false,
  };

  handleOnChange = (e) => {
    const { value } = e.target;
    this.setState({
      email: value.trim(),
      isSuccess: false,
      invalidEmail: false,
    });
  };

  handleTermBox = (e) => {
    const { checked } = e.target;
    this.setState({
      termsChecked: checked,
      invalidTerms: ! checked,
    });
  };

  handleNewsLetterCheckbox = (listID, checked) => {
    const {
      newsletterIds,
    } = this.state;
    const index = newsletterIds.indexOf(listID);
    const inList = - 1 !== index;

    if (checked && ! inList) {
      // add it.
      newsletterIds.push(listID);
    } else if (! checked && inList) {
      // remove it.
      newsletterIds.splice(index, 1);
    }

    this.setState({ newsletterIds, invalidNewletterIds: ! newsletterIds.length });
  };

  validateTermsCheckbox = () => {
    const {
      showTermsBox,
    } = this.props;

    const {
      termsChecked,
    } = this.state;

    if (! showTermsBox) {
      // not showing Terms Checkbox, so validate as true.
      return true;
    }

    // if we are showing the Terms Checkbox, return the value of termsChecked.
    return termsChecked;
  };

  handleFormSubmit = (e) => {
    const {
      email,
      newsletterIds,
    } = this.state;

    const {
      newsletterId,
      footerSignup,
      nonce,
      useNewsletterIds,
    } = this.props;

    e.preventDefault();

    //  User must have at least one of the boxes checked to submit for RSN
    if (useNewsletterIds) {
      this.handleNewsLetterCheckbox();
    }

    if (useNewsletterIds && ! newsletterIds?.length) {
      return;
    }

    if (! this.validateTermsCheckbox()) {
      this.setState({ invalidTerms: true });
      return;
    }

    if (
      email
      && (
        newsletterId
        || footerSignup
        || (useNewsletterIds && newsletterIds)
      )
    ) {
      const formData = {
        email,
        lists: {}, // custom var lists.
        mailingLists: {}, // mailing lists.
      };
      if (newsletterId) {
        formData.lists[newsletterId] = 1;
      } else if (footerSignup) {
        formData.footerSignup = true;
      } else if (newsletterIds) {
        newsletterIds.forEach((id) => {
          formData.mailingLists[id] = 1;
        });
      }
      const fetch = subscriberApi.updateSubscriber(formData, nonce);

      this.setState({ isLoading: true });

      fetch
        .then(() => {
          this.setState({
            isLoading: false,
            isSuccess: true,
            // eslint-disable-next-line no-nested-ternary
            email: footerSignup ? email : (useNewsletterIds ? email : __('Sign up successful!', 'nbc')),
          });
        })
        .catch((err) => {
          const {
            code = '',
          } = err;
          this.setState({
            isLoading: false,
            isSuccess: false,
            invalidEmail: 'sailthru-invalid-email' === code,
            email: '',
          });
        });
    }
  };

  getNewsletterCheckboxes = () => {
    const {
      props: {
        newsletterIds,
      },
      state: {
        invalidNewletterIds,
      },
    } = this;

    return Object.keys(newsletterIds).map((listName) => {
      const listID = newsletterIds[listName];
      const inputID = `newsletter_list_id_${listID}`;

      return (
        <label className="newsletter-widget__label" htmlFor={inputID}>
          <input
            id={inputID}
            className={`newsletter-widget__checkbox ${invalidNewletterIds ? 'newsletter-widget__checkbox--error' : ''}`}
            type="checkbox"
            onChange={(e) => this.handleNewsLetterCheckbox(listID, e.target.checked)}
          />
          <div className={`newsletter-widget__checkbox-name ${inputID}`}>{__(listName)}</div>
        </label>
      );
    });
  };

  render() {
    const {
      title,
      description,
      newsletterId,
      footerSignup,
      newsletterLink,
      privacyLink,
      showTermsBox,
      useNewsletterIds,
    } = this.props;
    const {
      email,
      isLoading,
      isSuccess,
      invalidEmail,
      invalidTerms,
      invalidNewsletterSelection,
      invalidNewletterIds,
    } = this.state;

    // at least one of these routes should be true.
    if (
      ! newsletterId
      && ! footerSignup
      && ! useNewsletterIds
    ) {
      return (null);
    }

    const formClasses = classNames({
      'short-form': true,
      loading: isLoading,
    });

    const successClass = classNames({
      success: isSuccess,
      invalidEmail,
    });

    return (
      <Fragment>
        <h3 className="widget-title newsletter-widget__title">{title}</h3>
        <p className="newsletter-widget__description">
          {description}
        </p>
        <div className="newsletter-widget__form-wrapper">
          <form
            className={formClasses}
            onSubmit={this.handleFormSubmit}
          >
            <div className="field-wrap display-flex">
              { useNewsletterIds ? this.getNewsletterCheckboxes() : '' }
              { ! footerSignup ? (
                <label
                  className={successClass}
                  htmlFor="name"
                >
                  {__('Enter your email', 'nbc')}
                </label>
              ) : ''}
              <input
                // eslint-disable-next-line max-len
                className={`newsletter-widget__email ${successClass} ${invalidTerms || 'invalidEmail' === successClass || invalidNewsletterSelection ? 'newsletter-widget__email--error' : ''}`}
                type="email"
                name="name"
                value={email}
                required
                onChange={this.handleOnChange}
                placeholder={__('Enter your email', 'nbc')}
              />
              {
                (showTermsBox && invalidEmail) ? (
                  <div className="newsletter-widget__message">Invalid email address, please try again.</div>
                ) : ''
              }
              {
                (showTermsBox && invalidTerms) ? (
                  <div className="newsletter-widget__message">You must be at least 18 years of age and agree to the NBCUniversal Privacy Policy and Terms of Use.</div>
                ) : ''
              }
              {
                (useNewsletterIds && invalidNewletterIds) ? (
                  <div className="newsletter-widget__message">You must choose at least one newsletter to sign up.</div>
                ) : ''
              }
              {
                showTermsBox ? (
                  <label htmlFor="newsletter_terms">
                    <input
                      id="newsletter_terms"
                      className={`newsletter-widget__checkbox ${invalidTerms || invalidNewsletterSelection ? 'newsletter-widget__checkbox--error' : ''}`}
                      type="checkbox"
                      onChange={this.handleTermBox}
                    />
                    <div className="newsletter-widget__terms">
                      I am at least 18 years of age and agree to the <a href="https://www.nbcuniversal.com/privacy" target="new">NBCUniversal Privacy Policy</a> and <a href="/terms-of-service/">Terms of Use</a>
                    </div>
                  </label>
                ) : ''
              }
              <button
                className={`newsletter-widget__button ${isSuccess ? 'newsletter-widget__button--success' : ''}`}
                type="submit"
                disabled={isLoading || isSuccess || invalidNewsletterSelection}
              >
                {
                  (footerSignup) ? (
                    <span className="newsletter-widget__button-text">
                      {
                        isSuccess ?
                          (<><span className="newsletter-widget__button-check" />confirmed</>) :
                          'Submit'
                      }
                    </span>
                  ) : (
                    <span className="newsletter-widget__button-text">
                      {
                        // eslint-disable-next-line no-nested-ternary
                        isLoading ?
                          '' :
                          (useNewsletterIds ? 'Submit' : __('Sign up', 'nbc'))
                      }
                    </span>
                  )
                }
              </button>
            </div>
          </form>
        </div>
        {
          ((privacyLink || newsletterLink) && ! showTermsBox) && (
            <div className="newsletter-widget__links">
              {
                privacyLink && (
                  <a
                    className="newsletter-widget__link"
                    href={privacyLink}
                  >
                    {__('Privacy Policy', 'nbc')}
                  </a>
                )
              }

              {
                newsletterLink && (
                  <a
                    className="newsletter-widget__link"
                    href={newsletterLink}
                  >
                    {__('More Newsletters', 'nbc')}
                  </a>
                )
              }
            </div>
          )
        }
      </Fragment>
    );
  }
}
